// extracted by mini-css-extract-plugin
module.exports =  {"credit-terms":"a10a3f92e9--credit-terms--UY0GF","terms":"a10a3f92e9--terms--hriot","term":"a10a3f92e9--term--T6RtY"};